import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const statusTimeLinePageContext = React.createContext({});
export let statusTimeLinePageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMStatusTimeLinePage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  statusTimeLinePageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(statusTimeLinePageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    statusTimeLinePageMachine,
    statusTimeLinePageState: state,
    statusTimeLinePageSend: send,
  };
};
